import axios from './axios'
import generateService from './generator'

function service(endpoint) {
    const base = generateService(endpoint);

    function addComponent(templateId, data) {
        return axios.post(`${endpoint}/${templateId}/components`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function updateComponent(templateId, componentId, data) {
        return axios.patch(`${endpoint}/${templateId}/components/${componentId}`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function destroyComponent(templateId, componentId) {
        return axios.delete(`${endpoint}/${templateId}/components/${componentId}`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function publish(templateId) {
        return axios.post(`${endpoint}/${templateId}/publish`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchList: base.fetchList,
        fetchAll: base.fetchAll,
        fetchItem: base.fetchItem,
        store: base.store,
        update: base.update,
        addComponent,
        updateComponent,
        destroyComponent,
        publish
    }
}

export default service
